import React, { FC, ReactElement } from 'react';
import { Box, Paragraph, Text } from 'grommet';
import { Subheading } from '@/components/Subheading';
import { BulletCheck } from '@/components/home/BulletCheck';
import { ThemeModeImage } from '@/components/ThemeModeImage';
import styled, { css } from 'styled-components';
import { normalizeColor } from 'grommet/utils';

export const LeftCircle = styled.div`
  ${({ theme }) => css`
    position: fixed;
    background-color: ${normalizeColor(`status-critical`, theme)};
    left: -50px;
    top: -50px;
    opacity: 0.15;
    border-radius: 100%;
    height: 5vw;
    width: 5vw;
    z-index: 0;
    max-height: 70px;
    max-width: 70px;
    box-shadow: 0 0 70px 70px ${normalizeColor(`status-critical`, theme)};
  `}
`;

const Section: FC<{ title: string; description: string }> = ({
  title,
  description,
}): ReactElement => (
  <Box direction="row" gap="small">
    <BulletCheck margin={{ top: `xsmall` }} />
    <Box>
      <Text size="large" weight="bold">
        {title}
      </Text>
      <Paragraph>{description}</Paragraph>
    </Box>
  </Box>
);

export const WhyUs: FC = (): ReactElement => (
  <Box direction="row-responsive" pad="medium" align="center">
    <Box animation="slideRight">
      <LeftCircle />
      <ThemeModeImage src="/img/timeline.svg" />
    </Box>
    <Box margin="medium">
      <Subheading>DISCOVER DATA BREACHES AND WEB VULNERABILITIES</Subheading>
      <Text size="xxlarge" margin={{ top: `small` }} weight="bold">
        24 / 7 Peace of Mind
      </Text>
      <Box margin={{ top: `medium` }}>
        <Section
          title="Instantly Scan"
          description="Within 5 minutes see which website vulnerabilities are publicly known, and see a sample of breached passwords and leaks associated to your company."
        />
        <Section
          title="Select a Plan"
          description="Based on your needs select a plan that makes the most sense for your company. Paid plans offer advanced scanning, and a full report of breaches."
        />
        <Section
          title="Ongoing Monitoring and Reports"
          description="24 / 7 peace of mind with monitoring, and monthly scanning of your assets. Our public and private data breaches consist of over 88,802,443,000 records."
        />
      </Box>
    </Box>
  </Box>
);
